import { VitalSourceEvents } from 'lib/constants.js';

import store from '../configureStore';


function VitalSourceEventHandler(vsEvent) {
  let handleEvent = {};

  handleEvent['page:scroll'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:navigationRequested'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:pagebreak'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['page:change'] = ({ page: data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchstart'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchend'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchmove'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['snippet:ready'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['page:load'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionMade'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionWithPosition'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['highlight:created'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['highlight:updated'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['highlight:deleted'] = (res) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data: res
    });
  };

  handleEvent['highlight:click'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:click'] = () => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent]
    });
  };

  handleEvent['noteicon:click'] = ({ ok, status, data }) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionCancelled'] = () => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent]
    });
  };

  return handleEvent[vsEvent];
}

// lint: warning  This generator function does not have 'yield'
function* bindAndHandleEvents() {
  for (const vsEvent of Object.keys(VitalSourceEvents)) {
    window.vsViewer.bind(vsEvent, VitalSourceEventHandler(vsEvent));
  }
}

export default bindAndHandleEvents;
